import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthContext } from '../models/auth-context';

@Injectable()
export abstract class AuthService {

  constructor() { }

  abstract authContext$: Observable<AuthContext>;

  abstract getAuthContext(): Observable<AuthContext>;

  abstract login(username: string, password: string): Observable<AuthContext>;

  abstract logout(): Observable<any>;

  abstract setPersonContext(authContext: AuthContext);
}
